<ng-template cxOutlet="cx-storefront" cxPageTemplateStyle>
  <ng-template cxOutlet="cx-header">
    <header
      cxSkipLink="cx-header"
      [cxFocus]="{ disableMouseFocus: true }"
      [class.is-expanded]="isExpanded$ | async"
    >
      <cx-page-layout section="preHeader"></cx-page-layout>
      <cx-page-layout section="header"></cx-page-layout>
      <cx-page-layout section="bottomHeader"></cx-page-layout>
      <cx-page-layout section="navigation"></cx-page-layout>
    </header>
    <div
      *ngIf="(baseSiteService.getActiveContext() | async)?.baseStore?.downForMaintenance"
      class="alert alert-danger"
    >
      <span>{{ 'common.systemDowntime' | cxTranslate }}</span>
    </div>
    <eb-no-sales-area-message></eb-no-sales-area-message>
    <cx-global-message *ngIf="!isModalShown"></cx-global-message>
  </ng-template>

  <main cxSkipLink="cx-main" [cxFocus]="{ disableMouseFocus: true }">
    <router-outlet></router-outlet>
    <eb-back-to-top-button></eb-back-to-top-button>
  </main>

  <ng-template cxOutlet="cx-footer">
    <footer cxSkipLink="cx-footer" [cxFocus]="{ disableMouseFocus: true }">
      <cx-page-layout section="footer"></cx-page-layout>
    </footer>
  </ng-template>
</ng-template>
